import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { DsCheckbox } from '@frontend/ui/checkbox';
import { DsRadioModule } from '@frontend/ui/radio-button';
import { EffectsModule } from '@ngrx/effects';

import DigitalSettingsComponent from './components/digital-settings.component';
import { DigitalOddAcceptanceEffects } from './effects/digital-odd-acceptance-effects';
import NotificationService from './services/notification.service';
import BetslipSettingsModule from './settings.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DsCheckbox,
        AutomationModule,
        BetslipSettingsModule,
        DsRadioModule,
        EffectsModule.forFeature([DigitalOddAcceptanceEffects]),
    ],
    providers: [NotificationService],
    declarations: [DigitalSettingsComponent],
    exports: [DigitalSettingsComponent],
})
export default class DigitalSettingsModule {}
